import { styled, svgIconClasses } from "@mui/material";
import { colorPickerName } from "../../../classes.js";
import { Chip, borderWidth } from "../../Swatch/components/Chip.js";
const PlaceholderChip = styled(Chip, {
  name: colorPickerName,
  slot: "PlaceholderChip"
})(({ theme, size }) => {
  const color = theme.palette.tidalColors.slateBlueGray[300];
  return {
    color,
    backgroundColor: theme.palette.common.white,
    boxShadow: "none",
    [`& .${svgIconClasses.root}`]: {
      border: `1px dashed ${color}`,
      fontSize: size - borderWidth * 2,
      opacity: 1,
      scale: "1",
      transition: "opacity 0.18s ease, scale 0.25s ease"
    }
  };
});
export {
  PlaceholderChip
};
//# sourceMappingURL=PlaceholderChip.js.map
